<template>
    <div>
        <main class="main-content">
            <div class="page-content">
                <div class="container-xl">
                    <section class="section-hotels">
                        <div class="page-title">
                            <h2>Hotels</h2>
                            <div class="page-title__side">
                                <form>
                                    <label class="form-control-checkbox check-show"
                                           @click.prevent="onlyActive = !onlyActive">
                                        <input type="checkbox" @click.prevent :checked="onlyActive"><span
                                        class="form-control-checkbox__box">
                                <svg width="1em" height="1em" class="icon icon-check ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                                </svg></span><span class="form-control-checkbox__name">Show only active hotels</span>
                                    </label>
                                    <div class="form-control-wrap search-hotel">
                                        <input type="text" placeholder="Search" v-model="search"
                                               class="form-control-search"/>
                                        <div class="form-control-icon">
                                            <svg width="1em" height="1em" class="icon icon-search ">
                                                <use
                                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-search"></use>
                                            </svg>
                                        </div>
                                    </div>
                                    <router-link to="/hotels/add/hotel" class="btn btn--green btn_add-hotel"><span>Add Hotel</span>
                                    </router-link>
                                </form>
                            </div>
                        </div>

                        <div class="hotels-table">
                            <simplebar data-simplebar="data-simplebar" class="section-table-wrap">
                                <table class="default-table-2 table-hotels">
                                    <thead>
                                    <tr>
                                        <th class="default-table-2__th default-table-2-title">
                                <span>
                                    <svg width="1em" height="1em" class="icon icon-sortable">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-sortable"></use>
                                    </svg>
                                    Hotel
                                </span>
                                        </th>
                                        <th class="default-table-2__th"></th>
                                        <th class="default-table-2__th td-country"><span>Country</span></th>
                                        <th class="default-table-2__th td-location"><span>Location</span></th>
                                        <th class="default-table-2__th td-area"><span>Area</span></th>
                                        <th class="default-table-2__th td-priority">
                                          <span>Priority</span>
                                        </th>
                                        <th class="default-table-2__th td-last-update">
                                <span class="sortable-ar">
                                    <svg width="1em" height="1em" class="icon icon-arrow-up">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-arrow-up"></use>
                                    </svg>Last Update
                                </span>
                                        </th>
                                        <th class="default-table-2__th td-price-up">
                                <span class="sortable-ar grow-ar">
                                    <svg width="1em" height="1em" class="icon icon-arrow-up">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-arrow-up"></use>
                                    </svg>Price Up To
                                </span>
                                        </th>
                                        <th class="default-table-2__th td-edit"><span></span></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item, index) in hotels.filter(item => onlyActive ? item.enabled : true).slice((page - 1) * 15, ((page - 1) * 15) + 15)"
                                        :key="item.id"
                                        :class="[{'status-stop' : !item.enabled, 'expired' : item.priceWarning}]">
                                        <td class="default-table-2-title">
                                            <router-link
                                                :to="{ name: 'hotels-advanced-add-hotel', params: { id: item.id } }"
                                                target="_blank" class="name-hotel-td">
                                                <span class="hotel-status"></span>
                                                <b>{{ item.title }}</b>
                                            </router-link>
                                        </td>
                                        <td class="td-alert">
                                            <span class="hotel-alert__help-icon" v-if="item.concessionWarning">
                                              <span class="hotel-alert__help-content">Concession fees are not included
                                              </span>
                                              <svg
                                                  class="icon hotel-location__alert-icon important-icon">
                                            <use
                                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
                                          </svg>
                                            </span>
                                        </td>
                                        <td class="td-country">
                                          <span class="mmt-tooltip">
                                            <span v-tooltip="{content: item.country.name, offset: 5}" :class="['flag-icon', 'flag-icon-squared', 'flag-icon-' + item.country.iso2.toLowerCase()]" />
                                          </span>
                                        </td>
                                        <td class="td-location">
                                          <span class="location-hotel">{{ item.location }}</span>
                                        </td>
                                        <td class="td-area"><span class="area-hotel">{{ item.area }}</span></td>
                                        <td class="td-priority">
                                          <img v-if="item.bestPrice"
                                               src="/images/useful/svg/hotel-best-price.svg"
                                               alt="Best Price"
                                          />
                                          <img v-else-if="item.lowPriority"
                                               src="/images/useful/svg/hotel-low-priority.svg"
                                               alt="Low Priority"
                                          />
                                        </td>
                                        <td class="td-last-update">
                                            <div class="td-av td-light">
                                                <div class="select-option__image h-object-fit"
                                                     :style="{background: 'grey'}"><img
                                                    v-if="item.lastUpdateInfo.user.photoUrl !== 'Unknown'"
                                                    :src="`${API}/documents/share/images/${item.lastUpdateInfo.user.photoUrl}?size=SMALL`"
                                                    alt="kiril"></div>
                                                {{ item.lastUpdateInfo.lastUpdate }}
                                            </div>
                                        </td>
                                        <td class="td-price-up"><span class="td-light price-up">{{
                                                item.priceValidUpTo
                                            }}</span></td>
                                        <td class="td-edit">
                                            <button type="button" class="btn btn--edit"
                                                    @click="$router.push(`/hotels/${item.id}/hotel`)">
                                                <svg width="1em" height="1em" class="icon icon-edit ">
                                                    <use
                                                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                                                </svg>
                                            </button>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </simplebar>
                        </div>
                        <Pagination
                            :page="page"
                            :pageCount="pageCount"
                            @pageController="pageController"
                        />
                    </section>
                </div>
            </div>
        </main>
    </div>
</template>

<script>

import Pagination from '@/components/Pagination'
import simplebar from 'simplebar-vue';

import {API, getHotelsAdvanced, getHotelsChains} from '@/utilites/api'

export default {
    data() {
        return {
            API,
            page: 1,
            pageCount: 0,
            search: '',
            isLoad: false,
            hotels: [],
            hotelsData: [],
            onlyActive: false,
            hotelsChain: []
        }
    },
    beforeCreate() {
        document.title = 'Hotels'
    },
    mounted() {
        this.updateData()
        getHotelsChains().then(res => {
            this.hotelsChain = res
        })
    },
    components: {Pagination, simplebar},
    methods: {
        pageController(page) {
            this.page = page
        },
        pageCountHandler() {
            this.pageCount = Math.ceil(this.hotels.length / 15)
        },
        updateData() {
            this.isLoad = false
            getHotelsAdvanced()
                .then(res => {
                    this.hotels = res
                    this.hotelsData = res
                    this.pageCount = Math.ceil(this.hotels.length / 15)
                    this.isLoad = true
                })
        },
    },
    watch: {
        search() {
            if (this.search.length === 0) {
                this.hotels = this.hotelsData
            }
            this.page = 1
            let filtered = this.hotelsData.filter(item => this.search.length ? (item.title && item.title.toLowerCase().includes(this.search.toLowerCase())) ? item : false : item)

            this.hotels = filtered
            if (!filtered.length) {
                const tempArray = this.hotelsChain.filter(hotelsChain => (hotelsChain.title && hotelsChain.title.toLowerCase().includes(this.search.toLowerCase())))
                this.hotels = this.hotelsData.filter(item => tempArray.map(temp => temp.id).includes(item.chainId))
            }
            this.pageCount = Math.ceil(filtered.length / 15)
        },
    }
}
</script>
<style scoped lang="scss">
.table-hotels {
  thead {
    .td-priority {
      text-align: center;
    }
  }

  tbody {
    .td-country,
    .td-priority {
      text-align: center;
    }

    .td-priority {
      width: 10%;
    }

    .td-priority img {
      width: 60px;
    }
  }
}

.hotel-alert {
  &__help-content {
    display: none;
    position: absolute;
    left: 25px;
    top: -4px;
    background: rgba(17, 17, 17, 0.7);
    color: white;
    border-radius: 10px;
    width: 200px;
    padding: 5px 10px;
  }

  &__help-icon {
    width: 20px;
    cursor: pointer;
    position: relative;

    svg {
      font-size: 20px;
      color: red;
    }

    &:hover .hotel-alert__help-content {
      display: block;
    }
  }
}
</style>
